import { Divider, Grid, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core"
import React, { useEffect } from "react";
import { LcmModel } from "../../domain/LcmModel";
import { DialogType, EntityDialog } from "./types";


const useStyles = makeStyles((theme) => ({
  menuDivider: {
    width: '90%',
  },
  menuItem: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(50), // Change width for screen sizes >= 600px
    }
  },
  label: {
    color: theme.palette.grey[50],
  }
}));

export const OptionsMenu: React.FC<{
  lcmItem: LcmModel,
  dialogType: DialogType,
  setFocusedEntity: (value: React.SetStateAction<EntityDialog | null>) => void
}> = ({ dialogType, setFocusedEntity, lcmItem }) => {
  const anchorRef = React.useRef(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const hasLineManagerAssigned =
    lcmItem.lineManagerUpn !== null && lcmItem.lineManagerUpn.trim().length > 0;
  const classes = useStyles();

  useEffect(() => {
    setMenuOpen(true);
  }, [dialogType])

  return (
    <Grid xs={12} container justifyContent="flex-end">
      <Grid item ref={anchorRef}>
        <Menu
          id="options-menu"
          ref={anchorRef}
          anchorEl={anchorRef.current}
          open={menuOpen}
          onClose={() => {
            setMenuOpen(false);
            setFocusedEntity(null)
          }}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <MenuItem disabled>
            <Typography variant='h1'>Select an option</Typography>
          </MenuItem>
          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>


          <MenuItem
            data-test="add-case-note-option"
            className={classes.menuItem}
            onClick={() => setFocusedEntity({ dialogType: DialogType.AddCaseNote })}>
            Add a case note
          </MenuItem>
          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>

          <MenuItem
            data-test="add-external-counsel-option"
            disabled={!hasLineManagerAssigned}
            className={classes.menuItem}
            onClick={() => setFocusedEntity({ dialogType: DialogType.AddExternalCounsel })}>
            Request External Counsel
          </MenuItem>
          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>

          <MenuItem
            data-test="add-time-record-option"
            className={classes.menuItem}
            onClick={() => setFocusedEntity({ dialogType: DialogType.AddTimeRecord })}>
            Record time/Cost
          </MenuItem>

          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>

          <MenuItem
            data-test="add-external-counsel-option"
            className={classes.menuItem}
            onClick={() => setFocusedEntity({ dialogType: DialogType.AddInternalMessage })}>
            Internal message

          </MenuItem>
          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>

          <MenuItem
            data-test="add-future-date-option"
            className={classes.menuItem} onClick={() => setFocusedEntity({ dialogType: DialogType.FutureEvent })}>
            Key date
          </MenuItem>

          <Grid container justifyContent="center">
            <Divider className={classes.menuDivider} />
          </Grid>

          <MenuItem
            data-test="add-email-option"
            className={classes.menuItem}
            onClick={() => setFocusedEntity({ dialogType: DialogType.AttachmentEmail })}>
            Attach an email
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  )
}